import React from 'react';
import { PropTypes, richTextPropTypes } from 'prop-types';
import RichText from '../rich-text';
import { Container } from '../styled/containers';

// Styles
import { Information } from './styles';

const InformationBanner = ({ text, color, metadata }) => (
  <Information
    $bgColor={color}
    data-funnelbacknoindex
    data-testid="information-banner"
  >
    <Container>
      <RichText richText={text} linkData={{ banner: metadata }} />
    </Container>
  </Information>
);

InformationBanner.propTypes = {
  text: PropTypes.shape(richTextPropTypes).isRequired,
  color: PropTypes.oneOf(['black', 'amber']).isRequired,
  metadata: PropTypes.string.isRequired,
};

export default InformationBanner;
